/**
 * @param {PresentationData} presentationData
 * @param {any} overrides
 * @returns {Promise<PresentationData>}
 */
export function overrideServerSettings(presentationData, overrides = {}) {
    // Apply user overrides passed to init() earlier
    const playerOptions = Object.assign({}, presentationData.playerOptions);
    for (const [key, value] of Object.entries(overrides)) {
        switch (typeof playerOptions[key]) {
            case 'object':
                playerOptions[key] = Object.assign({}, playerOptions[key], value);
                break;
            default:
                playerOptions[key] = value;
                break;
        }
    }

    return Promise.resolve(Object.assign({}, presentationData, { playerOptions }));
}
